/**
 * Row 2 of the homepage zigzag: visual LEFT, text RIGHT.
 */
import { Bot, Layers, Cpu, Boxes } from "lucide-react";

const TILES = [
  { icon: Bot,    label: "AI specialists",      color: "#202B60" },
  { icon: Layers, label: "12 business modules",  color: "#D4AF37" },
  { icon: Cpu,    label: "One data model",       color: "#202B60" },
  { icon: Boxes,  label: "15+ tools replaced",   color: "#0A1628" },
];

export default function HomeIntro() {
  return (
    <section id="about" data-testid="home-intro" className="zy-section bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* LEFT — icon tile grid */}
          <div className="zy-reveal">
            <div
              className="rounded-2xl border border-[#eef1f7] p-6 sm:p-8"
              style={{ background: "linear-gradient(160deg, #f7f9ff 0%, #eef2ff 100%)" }}
            >
              <div className="grid grid-cols-2 gap-4">
                {TILES.map((t, i) => {
                  const Icon = t.icon;
                  return (
                    <div
                      key={i}
                      className="rounded-xl bg-white p-5 flex flex-col items-start gap-3 shadow-sm"
                    >
                      <span
                        className="inline-flex items-center justify-center rounded-lg"
                        style={{ background: `${t.color}14`, width: 40, height: 40 }}
                      >
                        <Icon size={18} style={{ color: t.color }} />
                      </span>
                      <p className="text-[13.5px] font-semibold text-[#0A1628]">{t.label}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* RIGHT — text */}
          <div className="zy-reveal">
            <p className="zy-eyebrow mb-4">What is Zynthoro</p>
            <h2 className="zy-h2" data-testid="home-intro-oneliner">
              Zynthoro is an AI-powered business management platform combining CRM, project management,
              finance, marketing and automation in one place — supported by four AI specialists that
              understand your business.
            </h2>
          </div>
        </div>
      </div>
    </section>
  );
}
